import React, { useState } from 'react';
import './App.css';
import Hero from './components/Hero';
import RegistrationModal from './components/RegistrationModal';
import SuccessDialog from './components/SuccessDialog';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  const handleRegisterClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmitForm = (formData) => {
    console.log('Form submitted:', formData);
    setIsModalOpen(false);
    setIsSuccessOpen(true);

    // Redirect to Telegram after 3 seconds
    setTimeout(() => {
      window.location.href = 'https://t.me/+d-HW7niWXiUyNThk';
    }, 3000);
  };

  const handleCloseSuccess = () => {
    setIsSuccessOpen(false);
  };

  return (
    <div className="App">
      <Hero onRegisterClick={handleRegisterClick} />
      <RegistrationModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitForm}
      />
      <SuccessDialog
        isOpen={isSuccessOpen}
        onClose={handleCloseSuccess}
      />
    </div>
  );
}

export default App;
